/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/ReportDefinitionDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ReportDefinitionDetailTestIds = {
  btnCreateReport: "btn-create-report",
  btnDeleteReport: "btn-delete-report",
  btnEditReport: "btn-edit-report",
  btnMoveReport: "btn-move-report",
  btnRunQuery: "btn-run-query",
  cardScheduleSummary: "card-schedule-summary",
  cardTitleResults: "card-title-results",
  cardTitleScheduleSummary: "card-title-schedule-summary",
  inputCreateReportDescription: "input-create-report-description",
  inputCreateReportName: "input-create-report-name",
  inputEditReportDescription: "input-edit-report-description",
  inputEditReportName: "input-edit-report-name",
  linkBreadcrumbCategories: "link-breadcrumb-categories",
  linkBreadcrumbCategory: "link-breadcrumb-category",
  reportDefinitionCreatePage: "report-definition-create-page",
  reportDefinitionDetailPage: "report-definition-detail-page",
  textNoSchedule: "text-no-schedule",
  textNotificationTemplate: "text-notification-template",
  textRecipientEmails: "text-recipient-emails",
  textRecipientIdentitiesCount: "text-recipient-identities-count",
  textScheduleCron: "text-schedule-cron",
  textScheduleNextRun: "text-schedule-next-run"
} as const;
